/**
 * Gloria's problem list — GENERATED from the captured /conditions answer.
 * Do not hand-edit; re-run ~/march-demo-data/build-fixture.py.
 */

/* eslint-disable */
export interface ChartCondition {
  title: string;
  code: string;
  onset: string;
  status: string;
  resolved: string | null;
}

/** All 24 active conditions, exactly as the live system returned them. */
export const CHART_CONDITIONS: ChartCondition[] = [
  { title: 'Medication review due', code: 'SNOMED 314529007', onset: '2026-05-14', status: 'active', resolved: null },
  { title: 'Stress', code: 'SNOMED 73595000', onset: '2025-12-25', status: 'active', resolved: null },
  { title: 'Aortic valve stenosis', code: 'SNOMED 60573004', onset: '2023-06-22', status: 'active', resolved: null },
  { title: 'Disorder of kidney due to diabetes mellitus', code: 'SNOMED 127013003', onset: '2021-08-05', status: 'active', resolved: null },
  { title: 'Chronic kidney disease stage 1', code: 'SNOMED 431855005', onset: '2021-08-05', status: 'active', resolved: null },
  { title: 'Abnormal findings diagnostic imaging heart+coronary circulat', code: 'SNOMED 274531002', onset: '2019-12-03', status: 'active', resolved: null },
  { title: 'Ischemic heart disease', code: 'SNOMED 414545008', onset: '2019-11-21', status: 'active', resolved: null },
  { title: 'Idiopathic atrophic hypothyroidism', code: 'SNOMED 83664006', onset: '2015-08-24', status: 'active', resolved: null },
  { title: 'Hypertriglyceridemia', code: 'SNOMED 302870006', onset: '2014-10-23', status: 'active', resolved: null },
  { title: 'Essential hypertension', code: 'SNOMED 59621000', onset: '2014-10-23', status: 'active', resolved: null },
  { title: 'Metabolic syndrome X', code: 'SNOMED 237602007', onset: '2013-10-17', status: 'active', resolved: null },
  { title: 'Diabetes mellitus type 2', code: 'SNOMED 44054006', onset: '2013-10-17', status: 'active', resolved: null },
  { title: 'Refugee (person)', code: 'SNOMED 446654005', onset: '2009-09-24', status: 'active', resolved: null },
  { title: 'Osteoporosis', code: 'SNOMED 64859006', onset: '2006-09-07', status: 'active', resolved: null },
  { title: 'Dependent drug abuse', code: 'SNOMED 6525002', onset: '2001-04-14', status: 'active', resolved: null },
  { title: 'Body mass index 30+ - obesity', code: 'SNOMED 162864005', onset: '1992-07-30', status: 'active', resolved: null },
  { title: 'Impacted molars', code: 'SNOMED 196416002', onset: '1991-05-05', status: 'active', resolved: null },
  { title: 'Chronic intractable migraine without aura', code: 'SNOMED 124171000119105', onset: '1990-06-08', status: 'active', resolved: null },
  { title: 'Chronic pain', code: 'SNOMED 82423001', onset: '1990-03-05', status: 'active', resolved: null },
  { title: 'Chronic sinusitis', code: 'SNOMED 40055000', onset: '1990-02-27', status: 'active', resolved: null },
  { title: 'Loss of teeth', code: 'SNOMED 37320007', onset: '1968-10-03', status: 'active', resolved: null },
  { title: 'Past pregnancy history of miscarriage', code: 'SNOMED 161744009', onset: '1967-11-30', status: 'active', resolved: null },
  { title: 'Prediabetes', code: 'SNOMED 714628002', onset: '1965-09-09', status: 'active', resolved: null },
  { title: 'Anemia', code: 'SNOMED 271737000', onset: '1965-09-09', status: 'active', resolved: null },
];

/** REAL: the 106 dated diastolic readings, from the captured BP answer's
 *  own table. The answer states the count and both endpoints. */
export const DIASTOLIC_SERIES: Array<{ date: string; value: number }> = [
  { date: '1946-07-11', value: 82 },
  { date: '1946-08-15', value: 82 },
  { date: '1946-10-17', value: 82 },
  { date: '1946-12-19', value: 80 },
  { date: '1947-03-20', value: 80 },
  { date: '1947-06-19', value: 77 },
  { date: '1947-09-18', value: 80 },
  { date: '1947-12-18', value: 82 },
  { date: '1948-06-17', value: 75 },
  { date: '1948-12-16', value: 81 },
  { date: '1949-06-16', value: 81 },
  { date: '1949-12-15', value: 78 },
  { date: '1950-06-15', value: 78 },
  { date: '1950-12-28', value: 81 },
  { date: '1951-06-21', value: 81 },
  { date: '1952-06-26', value: 73 },
  { date: '1953-03-26', value: 75 },
  { date: '1953-07-02', value: 77 },
  { date: '1954-07-08', value: 81 },
  { date: '1955-07-14', value: 72 },
  { date: '1956-07-19', value: 79 },
  { date: '1957-07-25', value: 80 },
  { date: '1958-07-31', value: 73 },
  { date: '1959-08-06', value: 80 },
  { date: '1960-08-11', value: 81 },
  { date: '1961-08-17', value: 81 },
  { date: '1962-08-23', value: 82 },
  { date: '1963-06-04', value: 95.551 },
  { date: '1963-08-29', value: 68 },
  { date: '1964-09-03', value: 78 },
  { date: '1965-09-09', value: 82 },
  { date: '1968-09-12', value: 79 },
  { date: '1971-09-16', value: 96 },
  { date: '1974-09-19', value: 84 },
  { date: '1977-09-22', value: 84 },
  { date: '1980-09-25', value: 85 },
  { date: '1983-09-29', value: 83 },
  { date: '1986-07-17', value: 84 },
  { date: '1988-07-21', value: 97 },
  { date: '1990-07-26', value: 84 },
  { date: '1990-08-09', value: 88 },
  { date: '1992-07-30', value: 92 },
  { date: '1994-08-04', value: 86 },
  { date: '1996-03-28', value: 83 },
  { date: '1996-07-11', value: 89 },
  { date: '1997-07-17', value: 88 },
  { date: '1998-07-23', value: 87 },
  { date: '1999-07-29', value: 89 },
  { date: '2000-08-03', value: 91 },
  { date: '2001-08-09', value: 96 },
  { date: '2002-08-15', value: 85 },
  { date: '2003-08-21', value: 88 },
  { date: '2004-08-26', value: 83 },
  { date: '2005-09-01', value: 84 },
  { date: '2006-09-07', value: 84 },
  { date: '2007-03-29', value: 86 },
  { date: '2007-09-13', value: 93 },
  { date: '2008-09-18', value: 88 },
  { date: '2009-09-24', value: 85 },
  { date: '2010-09-30', value: 86 },
  { date: '2011-10-06', value: 87 },
  { date: '2012-03-15', value: 82 },
  { date: '2012-10-11', value: 83 },
  { date: '2013-10-17', value: 101 },
  { date: '2014-10-23', value: 109 },
  { date: '2014-11-22', value: 80 },
  { date: '2015-01-21', value: 68 },
  { date: '2015-03-22', value: 72 },
  { date: '2015-10-29', value: 67 },
  { date: '2016-11-03', value: 76 },
  { date: '2017-11-09', value: 75 },
  { date: '2018-09-06', value: 71 },
  { date: '2018-11-15', value: 71 },
  { date: '2019-01-24', value: 69 },
  { date: '2019-04-25', value: 68 },
  { date: '2019-11-21', value: 74 },
  { date: '2020-11-26', value: 58 },
  { date: '2021-08-05', value: 68 },
  { date: '2021-12-02', value: 62 },
  { date: '2022-01-06', value: 68 },
  { date: '2022-02-03', value: 60 },
  { date: '2022-03-03', value: 62 },
  { date: '2022-05-05', value: 62 },
  { date: '2022-06-02', value: 67 },
  { date: '2022-08-04', value: 60 },
  { date: '2022-11-03', value: 59 },
  { date: '2022-12-08', value: 65 },
  { date: '2023-02-02', value: 64 },
  { date: '2023-03-02', value: 59 },
  { date: '2023-08-31', value: 73 },
  { date: '2023-09-28', value: 58 },
  { date: '2023-10-26', value: 63 },
  { date: '2023-12-14', value: 58 },
  { date: '2024-04-25', value: 61 },
  { date: '2024-06-20', value: 64 },
  { date: '2024-09-19', value: 59 },
  { date: '2024-11-21', value: 61 },
  { date: '2024-12-19', value: 66 },
  { date: '2025-03-20', value: 59 },
  { date: '2025-07-17', value: 62 },
  { date: '2025-08-14', value: 59 },
  { date: '2025-09-18', value: 66 },
  { date: '2025-12-25', value: 65 },
  { date: '2026-04-16', value: 59 },
  { date: '2026-05-14', value: 59 },
  { date: '2026-07-16', value: 58 },
];
